






































import { Component, Prop, Vue } from 'vue-property-decorator';
import type { PMPhase } from '@/models/pmphase';
import type { PMAppliedLesson } from '@/models/pmappliedlesson';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'PMPhaseWorksheet',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {},
})
export default class PMPhaseWorksheet extends Vue {
    @Prop() private selectedPhase: PMPhase;

    private havePMWorksheet(pmPhase: PMPhase) {
        return pmPhase.worksheet !== null;
    }

    private getPMClass(pmPhase: PMPhase) {
        if (!this.havePMWorksheet(pmPhase)) {
            return '';
        } else {
            let done = true;
            if (pmPhase.worksheet) {
                pmPhase.worksheet.pm_applied_lessons.forEach((pmAppliedLesson: PMAppliedLesson) => {
                    if (!pmAppliedLesson.done) {
                        done = false;
                        return;
                    }
                });
            }

            return !done ? 'is-danger' : 'is-success';
        }
    }

    private showWorksheet(pmphase: PMPhase, onlyPR: boolean = false) {
        if (pmphase.worksheet !== null) {
            this.$router.push({
                name: 'WorksheetView',
                query: {
                    id: pmphase.worksheet.id.toString(),
                    onlyPR: String(onlyPR),
                    type: 'pm',
                },
            });
        } else {
            this.$router.push({
                name: 'CreateWorksheetPM',
                query: {
                    phaseId: pmphase.id + '',
                },
            });
        }
    }

    private getClassHB(pmPhase: PMPhase) {
        if (pmPhase.worksheet === null) {
            return '';
        } else {
            let done = true;
            if (pmPhase.worksheet.pm_applied_lessons.length === 0) {
                return '';
            }
            pmPhase.worksheet.pm_applied_lessons.forEach((pmAppliedLesson: PMAppliedLesson) => {
                if (!pmAppliedLesson.done) {
                    done = false;
                    return;
                }
            });
            return !done ? 'is-danger' : 'is-success';
        }
    }

    private getClassPR(pmPhase: PMPhase) {
        if (pmPhase.worksheet === null) {
            return '';
        } else {
            let needsCheck = false;
            let hasBeenChecked = true;
            pmPhase.worksheet.pm_applied_lessons.forEach((pmAppliedLesson: PMAppliedLesson) => {
                if (pmAppliedLesson.needscheck) {
                    needsCheck = true;
                    if (!pmAppliedLesson.checked) {
                        hasBeenChecked = false;
                        return;
                    }
                }
            });

            return needsCheck ? (hasBeenChecked ? 'is-success' : 'is-danger') : '';
        }
    }
}
